<template>
<div class="checkbox-wrapper check-box-container">
	<div>
		<span class="checkbox">
			<input :id='"filter_check_box"+id' class='checkbox-box' type="checkbox" v-model="internal_value" :value="value" :checked='checked' :disabled='disabled' />
			<svg>
				<use xlink:href="#checkbox-30" class="checkbox"></use>
			</svg>
		</span>
		<svg xmlns="http://www.w3.org/2000/svg" style="display:none">
			<symbol id="checkbox-30" viewBox="0 0 22 22">
				<path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2" />
			</symbol>
		</svg>
	</div>
	<div v-if='label!= ""' class='label-check-box-container'>
		<div>{{label}}</div>
		<div class='counter' v-if='counter'>({{counter}})</div>
	</div>
</div>

</template>

<script>
  export default {
    props: ['id', 'checked','value', 'label', 'disabled', 'counter'],
    emits:['checkBoxListener'],
    model: {
        prop: "checked"
    },
    computed:{
      internal_value: {
        get(){
            return this.checked
        },
        set(box_checked){
            this.$emit("checkBoxListener", this.id, box_checked); 
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.check-box-container{
    display:flex; 
    font-size: 0.8rem; 
    gap: 10px; 
    align-items: center;
}

.label-check-box-container{
    align-self: baseline;
    display: flex; 
    gap: 8px;
    align-items: center;
}

.counter{
    // font-size: 0.85rem;
    color: var(--grey-1);
    // align-self: normal;
}
.checkbox-wrapper .checkbox {
   --bg: #fff;
   --brdr: #d1d6ee;
   --brdr-actv: #1e2235;
   --brdr-hovr: #bbc1e1;
   --dur: calc((var(--size, 2) / 2) * 0.6s);
    display: inline-block;
    width: 22px;
    position: relative;
}
.checkbox-wrapper .checkbox:after {
   content: "";
   width: 100%;
   padding-top: 100%;
   display: block;
}
.checkbox-wrapper .checkbox > * {
   position: absolute;
}
.checkbox-wrapper .checkbox input {
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;
   -webkit-tap-highlight-color: transparent;
   cursor: pointer;
   background-color: var(--bg);
   border-radius: calc(var(--size, 1) * 4px);
   border: calc(var(--newBrdr, var(--size, 1)) * 1px) solid;
   color: var(--newBrdrClr, var(--brdr));
   outline: none;
   margin: 0;
   padding: 0;
   transition: all calc(var(--dur) / 3) linear;
}
.checkbox-wrapper .checkbox input:hover,
.checkbox-wrapper .checkbox input:checked {
   --newBrdr: calc(var(--size, 1) * 2);
}
.checkbox-wrapper .checkbox input:hover {
   --newBrdrClr: var(--brdr-hovr);
}
.checkbox-wrapper .checkbox input:checked {
   --newBrdrClr: var(--brdr-actv);
   transition-delay: calc(var(--dur) / 1.3);
}
.checkbox-wrapper .checkbox input:checked + svg {
   --dashArray: 16 93;
   --dashOffset: 109;
}
.checkbox-wrapper .checkbox svg {
   fill: none;
   left: 0;
   pointer-events: none;
   stroke: var(--stroke, var(--border-active));
   stroke-dasharray: var(--dashArray, 93);
   stroke-dashoffset: var(--dashOffset, 94);
   stroke-linecap: round;
   stroke-linejoin: round;
   stroke-width: 2px;
   top: 0;
   transition: stroke-dasharray var(--dur), stroke-dashoffset var(--dur);
}
.checkbox-wrapper .checkbox svg,
.checkbox-wrapper .checkbox input {
   display: block;
   height: 100%;
   width: 100%;
}
</style>